import { render, staticRenderFns } from "./contact-section.vue?vue&type=template&id=0dcee4a2"
import script from "./contact-section.vue?vue&type=script&lang=js"
export * from "./contact-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports